import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename'

// this allows to send in a mutation an object we got from a query
export const removeTypenameLink = removeTypenameFromVariables()
